import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { GrowthBook } from '@growthbook/growthbook';
export { GrowthBook, clearCache, configureCache, setPolyfills } from '@growthbook/growthbook';
import * as React from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var GrowthBookContext = /*#__PURE__*/React.createContext({});

function run(exp, growthbook) {
  if (!growthbook) {
    return {
      featureId: null,
      value: exp.variations[0],
      variationId: 0,
      inExperiment: false,
      hashUsed: false,
      hashAttribute: exp.hashAttribute || "id",
      hashValue: "",
      key: ""
    };
  }

  return growthbook.run(exp);
}

function feature(id, growthbook) {
  if (!growthbook) {
    return {
      value: null,
      on: false,
      off: true,
      source: "unknownFeature",
      ruleId: ""
    };
  }

  return growthbook.evalFeature(id);
} // Get features from API and targeting attributes during SSR


function getGrowthBookSSRData(_x) {
  return _getGrowthBookSSRData.apply(this, arguments);
} // Populate the GrowthBook instance in context from the SSR props


function _getGrowthBookSSRData() {
  _getGrowthBookSSRData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var gb, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Server-side GrowthBook instance
            gb = new GrowthBook(_objectSpread({}, context)); // Load feature flags from network if needed

            if (!context.clientKey) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return gb.loadFeatures();

          case 4:
            data = {
              attributes: gb.getAttributes(),
              features: gb.getFeatures()
            };
            gb.destroy();
            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGrowthBookSSRData.apply(this, arguments);
}

function useGrowthBookSSR(data) {
  var gb = useGrowthBook(); // Only do this once to avoid infinite loops

  var isFirst = React.useRef(true);

  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}

function useExperiment(exp) {
  var _React$useContext = React.useContext(GrowthBookContext),
      growthbook = _React$useContext.growthbook;

  return run(exp, growthbook);
}

function useFeature(id) {
  var growthbook = useGrowthBook();
  return feature(id, growthbook);
}

function useFeatureIsOn(id) {
  var growthbook = useGrowthBook();
  return growthbook ? growthbook.isOn(id) : false;
}

function useFeatureValue(id, fallback) {
  var growthbook = useGrowthBook();
  return growthbook ? growthbook.getFeatureValue(id, fallback) : fallback;
}

function useGrowthBook() {
  var _React$useContext2 = React.useContext(GrowthBookContext),
      growthbook = _React$useContext2.growthbook;

  return growthbook;
}

function FeaturesReady(_ref) {
  var children = _ref.children,
      timeout = _ref.timeout,
      fallback = _ref.fallback;
  var gb = useGrowthBook();

  var _React$useState = React.useState(gb ? gb.ready : false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ready = _React$useState2[0],
      setReady = _React$useState2[1];

  React.useEffect(function () {
    if (timeout && !ready) {
      var timer = setTimeout(function () {
        setReady(true);
      }, timeout);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [timeout, ready]);
  return ready ? children : fallback || null;
}

function IfFeatureEnabled(_ref2) {
  var children = _ref2.children,
      feature = _ref2.feature;
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}

function FeatureString(props) {
  var value = useFeature(props.feature).value;

  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.default);
}

var withRunExperiment = function withRunExperiment(Component) {
  // eslint-disable-next-line
  var withRunExperimentWrapper = function withRunExperimentWrapper(props) {
    return /*#__PURE__*/React.createElement(GrowthBookContext.Consumer, null, function (_ref3) {
      var growthbook = _ref3.growthbook;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        runExperiment: function runExperiment(exp) {
          return run(exp, growthbook);
        }
      }));
    });
  };

  return withRunExperimentWrapper;
};

withRunExperiment.displayName = "WithRunExperiment";

var GrowthBookProvider = function GrowthBookProvider(_ref4) {
  var children = _ref4.children,
      growthbook = _ref4.growthbook;

  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      _ = _React$useState4[0],
      setRenderCount = _React$useState4[1];

  React.useEffect(function () {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(function () {
      setRenderCount(function (v) {
        return v + 1;
      });
    });
    return function () {
      growthbook.setRenderer(function () {// do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/React.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook: growthbook
    }
  }, children);
};

export { FeatureString, FeaturesReady, GrowthBookContext, GrowthBookProvider, IfFeatureEnabled, getGrowthBookSSRData, useExperiment, useFeature, useFeatureIsOn, useFeatureValue, useGrowthBook, useGrowthBookSSR, withRunExperiment };